import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SummariesService {
  constructor(private httpClient: HttpClient) {}

  getSummaryReportByType(payload: any) {
    let url = `/summaries/list`;
    return this.httpClient.post(url, payload);
  }

  getAgentSummaryReportByType(payload: any) {
    let url = `/summaries/agentList`;
    return this.httpClient.post(url, payload);
  }

  getChatSummaryReport(payload: any) {
    let url = `/conversation/list`;
    return this.httpClient.post(url, payload);
  }

  userStatusMonitoring(payload: any) {
    let url = `/user/userStatusMonitoring`;
    return this.httpClient.post(url, payload);
  }

  
  callRecordings(payload: any) {
    let url = `/recordings/calls`;
    return this.httpClient.post(url, payload);
  }

  
  getAllVoicemails(payload: any) {
    let url = `/recordings/voicemails`;
    return this.httpClient.post(url, payload);
  }
  
  getOfflineMessages(payload: any) {
    let url = `/offlinemessage`;
    return this.httpClient.post(url, payload);
  }

  allOpenLeads(payload: any) {
    let url = `/lead/allOpenAssignedLeads`;
    return this.httpClient.post(url, payload);
  }

  callMonitorReport(payload: any) {
    let url = `/calls/monitoring`;
    return this.httpClient.post(url, payload);
  }
}
